import { DatabaseTagsModel } from "@models/database-tags.model";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { EntityTagActions } from "./entity-tag.action-types";

export interface EntityTagState extends EntityState<DatabaseTagsModel.EntityTagDocument> {
    tagEntities: DatabaseTagsModel.EntityTagDocument[],
    isLoading: boolean;
    lastCreatedAt: number;
    perPage: number;
    isLastPage: boolean;
}

export const adapter: EntityAdapter<DatabaseTagsModel.EntityTagDocument> = createEntityAdapter<DatabaseTagsModel.EntityTagDocument>({
    selectId: (entityTag: DatabaseTagsModel.EntityTagDocument) => entityTag._id,
});

export const initialState: EntityTagState = adapter.getInitialState({
    tagEntities: null,
    isLoading: false,
    lastCreatedAt: null,
    perPage: 20,
    isLastPage: false,
});

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

export const entityTagStateReducer = createReducer(
    initialState,
    on(EntityTagActions.resetToInitialState, state => {
        return {
            ...initialState,
        };
    }),
    on(EntityTagActions.getEntitiesByTagSuccess, (state, { entitiesByTag }) => {
        const latestCreatedAt = entitiesByTag.length > 0 
            ? entitiesByTag[entitiesByTag.length - 1].createdAt
            : state.lastCreatedAt;
            
        return adapter.addMany(entitiesByTag, {
            ...state,
            isLastPage: entitiesByTag.length < state.perPage,
            lastCreatedAt: latestCreatedAt,
        });
    }),
    on(EntityTagActions.setIsLoading, (state, { isLoading }) => {
        return {
            ...state,
            isLoading: isLoading,
        };
    }),
    on(EntityTagActions.resetList, (state) => {
        return adapter.removeAll({
            ...state,
            isLastPage: initialState.isLastPage,
            lastCreatedAt: initialState.lastCreatedAt,
        });
    }),
)